import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TextEllipsis } from '../text-ellipsis';

export const Wrapper = styled(Card)`
  border: none;
  box-shadow: none;
  border-radius: ${(p) => p.theme.spacing(0.5)};
`;

export const Email = styled(TextEllipsis)``;
